export interface TraceAbilityState {
    getRecLotByRecLotIdSuccess : any;
    getRecLotByRecLotIdError : any;
    getMLCByInternalCodeSuccess : any;
    getMLCByInternalCodeError : any;
    getRecLotByMaterialIdSuccess : any;
    getRecLotByMaterialIdError : any;
    getMLCsByFormulaIdSuccess : any;
    getMLCsByFormulaIdError : any;
    getMaterialTraceabilitySuccess : any;
    getMaterialTraceabilityError : any;
    getProductTraceabilitySuccess : any;
    getProductTraceabilityError : any;
}

export const initialTraceAbilityState : TraceAbilityState =  {
    getRecLotByRecLotIdSuccess : null,
    getRecLotByRecLotIdError : null,
    getMLCByInternalCodeSuccess : null,
    getMLCByInternalCodeError : null,
    getRecLotByMaterialIdSuccess : null,
    getRecLotByMaterialIdError : null,
    getMLCsByFormulaIdSuccess : null,
    getMLCsByFormulaIdError : null,
    getMaterialTraceabilitySuccess : null,
    getMaterialTraceabilityError : null,
    getProductTraceabilitySuccess : null,
    getProductTraceabilityError : null,
}